export const SEND_CODE_ON_PHONE = (phone: string): string => `/verification/phone/${phone}`;
export const SEND_CODE_ON_EMAIL = (email: string): string => `/verification/email/${email}`;
export const VERIFIY_PHONE_CODE_URL = (phone: string): string => `/verification/phone/${phone}/status`;
export const VERIFIY_EMAIL_CODE_URL = (email: string): string => `/verification/email/${email}/status`;
